import React from 'react';
import { string } from '../../../localization';
import './RotateTool.scss';

export const RotateTool = props => {
  const {
    rotateModalValue,
    rotateRight,
    rotateLeft,
    getRotateModalValue
  } = props;

  const rotateString = document.createElement('canvas');
  const ctx = rotateString.getContext('2d');
  ctx.font = '12px/14px HPSimplifiedLight, Arial, sans-serif';
  const width1 = ctx.measureText(string.ROTATE_RIGHT_KEY).width;
  const width2 = ctx.measureText(string.ROTATE_LEFT_KEY).width;
  const rotateButtonWidth = width1 > width2 ? width1 + 70 : width2 + 70;

  return (
    <div className='undraggable'>
      <div className='mt-2 d-flex justify-content-center'>
        <button
          type='button'
          style={{ width: rotateButtonWidth }}
          className='rotate-action-box'
          onClick={() => rotateRight()}
        >
          <img
            alt='rotate-right'
            src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAkBJREFUeNqEUkuL01AUTjKtbXUmM3UKomSwDg5K7QziCFrHRaCgdNeHih0FmVm50o0gzsBsCq5cFAsyXfgTqguzsW7cWETyB4qBChXbTts0aZM+8qrnxqRgDHjh5OSce7/vnPvdg+MEgbktXdN84LxzHo+E/We5Mhi6Pofj+AVd1w+y2SxpkbJgl93OexzVr4J7Mp1ONfDzBEGsxuPxE9Vq9SnksI/l8ivIPwbjXDvRVPUuVD7keT7EcVx4OByuDgYDLJFIXPtZr99CJDe3thZjsdgdZyeobWwyHi8bhvGyVquJ6xsbv3o8L0Sj0VChUGh8YJjul0rl7P7e3hk4CxISIYZhPgFWnrEgYUejUVgQhK/JVOotxAf5fP4k+CvHfL7X4G+DXYczrCRJbKPR+BaJRHYRzjbz0+/3w81m873P738DccTa9FueQB4RQCEWrsvmcrl3kFuwSUxNFpeWfgiiWN/d2fFCWLWaHNuPZYqu65imaRjSJp1OnyZJkv5H2OOBwLPDYpGF300Uy5K0MpTlR512u2wyGcaMKBgMeh9sb99DmpqSOIbNKw0G66AfDaAEAILdbhc7v7b2uX10RE8mkz86wmN857gRTdPPIazM5gTAN8CloNqmqqqkoihmVVk2H2HB7sReKxQVyGQyD0ulUsUj9HoZYL4PVc4hIKpm392cHwvoJEHdpJLJi0ByydNqtVJ8r3cK7q/AgM3AztXpdDBRFP8ioShqHn7jtib7YMvWvgLmxvQCrOiSV34LMAC1hSNtveAvcQAAAABJRU5ErkJggg=='
          />
          {string.ROTATE_RIGHT_KEY}
        </button>
      </div>

      <div className='mt-1 d-flex justify-content-center'>
        <button
          type='button'
          style={{ width: rotateButtonWidth }}
          className='rotate-action-box'
          onClick={() => rotateLeft()}
        >
          <img
            alt='rotate-left'
            src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAipJREFUeNp8k89r02AYx5MssT/SgmnpWg/quvMmc2OXbXh2hyE7qdi7ILK/QBx42QoiqId59eBlMAQvwwkDLXravPTidCWCdEvpj5S0yWzyvqnfN/QNm66+8PA+efK8n3zf53kiipIk/G9RQhLYvBFZ7g3L+YfgUzqFg3sDXxFF8VGlUrlWKBRiwyDi30qI5z1zXfeGmkjsw/+M0IphGKaqqnUYBfS5rCh7Q5V4rnu53+8vOI4jxGIxkRCyAmO+puv6pWq1esX3/VelUunhUAgAd5Ek9Xo9AaD+0fHxk8erqzhbpWvr6/Xr09OffhwednPZ7L2F+fklfk7mzu+TEw2AW5RSgRlb+Xz+XTKZbBSLxaSmaUumab6NRiIfoOyp7TiLSPkIs0IIAMtQEkE9BHYFvjqdzhemGID32KOZTIa0220DOVE8x0NIx7IUQG57nhcATkP4N7hgrEV87Fu5XHbOXAfBm4CkmQr4TFXw0u52dwB8g9juRU37xWKj2ex2Lpez4E7AjLDFbdPchIpxVlC2IFeYmJzcbzWbM0wd9X3bse2dVCq1nUqnvw4EKKyhQXeQOIdCjkOmwIvKC8sAQZwQNR6PL6NjL74fHGw0G405DgiuA+l3WDKzcNQHEFYbdsVwHiQJzYnMQvHsT10/wuC9vjo2tiXXarUZy7LCg4MaBXur1aphyLSzIy4KAEkowyhq9gChOh/7l7AL5/wW92Fr5/0up/KbfwQYAP7aSX9ZOtc+AAAAAElFTkSuQmCC'
          />
          {string.ROTATE_LEFT_KEY}
        </button>
      </div>

      <div className='d-flex mt-2 justify-content-center align-items-center custom-input-box'>
        {string.ROTATION_KEY}
        <input
          className='form-control form-control-sm ml-1'
          type='number'
          value={rotateModalValue}
          onChange={e => getRotateModalValue(e)}
        />
      </div>
    </div>
  );
};
